import delay from "./delay";

/**
 * 重试函数
 */
export async function retry<T extends (...args: any) => any>(
    fn: T,
    retryTime: number,
): Promise<Awaited<ReturnType<T>>> {
    let time = 1;

    while (true) {
        try {
            return await fn();
        } catch (error) {
            if (time > retryTime) {
                throw error;
            }

            time++;

            await delay(1000 * 2 ** time);
        }
    }
}
